import React from "react";
import Container from "@mui/material/Container";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";
import ReactLoading from "react-loading";
import { useState } from "react";
import DOMPurify from "dompurify";
import Swal from "sweetalert2";
import Axios from "axios";
import { useSelector } from "react-redux";
import { BaseUrlQuejas } from "../../../services/axios/AxiosEndpoints";

const FormPresentarQuejas = () => {
  const [guardarQuejas, setGuardarQuejas] = useState([]);
  const [errorGuardarQuejas, setErrorGuardarQuejas] = useState([]);
  const [statusguardarRegistro, setStatuGuardarQuejas] = useState();

  const [isFetching, setIsFetching] = useState(false);

  const [detalle, setDetalle] = useState("");
  const [telefono, setTelefono] = useState();
  const [fileAnexos, setFileAnexos] = useState("");

  const { descripcion, codPss } = useSelector((state) => state.user);

  const MaxSizeFileKyloByte = 10000000;

  /*--------------------------------- --------------------------------- */

  const validate = () => {
    let errors = {};

    if (!detalle) {
      errors.detalle = "Este campo no puede estar vacío";
    }

    if (!telefono) {
      errors.telefono = "Este campo no puede estar vacío";
    }

    if (!fileAnexos) {
      errors.fileAnexos = "Este campo no puede estar vacío";
    }

    return errors;
  };

  /*--------------------------------- --------------------------------- */

  const validateFile = (file) => {
    const allowedExtensions = ["pdf", "jpg", "jpeg", "png"];
    const extension = file.name.split(".").pop().toLowerCase();
    return allowedExtensions.includes(extension);
  };

  /*--------------------------------- --------------------------------- */

  const HandleAnexos = (event) => {
    const file = event.target.files[0];
    // Validación de la extensión del archivo
    if (file && !validateFile(file)) {
      Swal.fire({
        title: "",
        text: "Los tipos de archivos permitidos son PDF, JPG ó PNG",
        icon: "warning",
        confirmButtonText: "Aceptar",
      });
    }
    if (file > MaxSizeFileKyloByte) {
      Swal.fire({
        title: "",
        text: "El archivo es demasiado grande, el tamaño maximo es de 10MB",
        icon: "warning",
        confirmButtonText: "Ok",
      });
    } else {
      setFileAnexos(file);
    }
  };

  /*--------------------------------- --------------------------------- */

  const HandleChangeDetalle = (e) => {
    const inputValue = e.target.value;
    setDetalle(inputValue);
  };

  /*--------------------------------- --------------------------------- */

  const HandleChangeTelefono = (event) => {
    // Obtén el valor actual del campo de identificación
    let { value } = event.target;

    // Elimina los guiones existentes y cualquier carácter que no sea un número
    value = value.replace(/[^0-9]/g, "");

    // Agrega guiones en las posiciones correspondientes
    if (value.length > 3 && value.length <= 6) {
      value = `${value.slice(0, 3)}-${value.slice(3)}`;
    } else if (value.length > 6 && value.length <= 10) {
      value = `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6)}`;
    }

    // Actualiza el estado con el nuevo valor formateado
    setTelefono(value);
  };

  /*--------------------------------- --------------------------------- */

  const HandleSubmitPresentarQueja = async (e) => {
    e.preventDefault();

    setIsFetching(true);

    const file = new FormData();

    file.append("files", fileAnexos);

    const sanitizedDetalle = DOMPurify.sanitize(detalle);
    const sanitizedContacto = DOMPurify.sanitize(telefono);

    await Axios({
      url: `${BaseUrlQuejas}/enviarQueja`,
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "multipart/form-data",
      },
      data: {
        CodAfi: codPss,
        Detalle: sanitizedDetalle,
        Contacto: sanitizedContacto,
        anexos: fileAnexos,
        Canal: 2,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          setGuardarQuejas(response.data);
          setStatuGuardarQuejas(response.status);
          Swal.fire({
            title: "Listo",
            text: "Solicitud enviada exitosamente",
            icon: "success",
            confirmButtonText: "Ok",
          });
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 400) {
            setErrorGuardarQuejas("El recurso no fue encontrado.");
          } else if (error.response.status === 500) {
            setErrorGuardarQuejas("Ha ocurrido un error en el servidor");
          }

          setErrorGuardarQuejas(error.response.data);
          Swal.fire({
            title: "",
            text: error.response.data,
            icon: "warning",
            confirmButtonText: "Ok",
          });
        } else if (error.request) {
          Swal.fire({
            title: "",
            text: error.request,
            icon: "warning",
            confirmButtonText: "Ok",
          });
        }
      })
      .finally(() => setIsFetching(false));
  };

  /*--------------------------------- --------------------------------- */

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  return (
    <Container
      maxWidth="lx"
      sx={{
        mt: { xs: 4, sm: 4, md: 2, lg: 2 },
        mb: { xs: 2, sm: 2, md: 2, lg: 2 },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          marginTop: { xs: "20px", sm: "20px", md: "60px", lg: "60px" },
          marginBottom: { xs: "60px", sm: "60px", md: "0px", lg: "0px" },
          position: "relative",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "20px",
              sm: "20px",
              md: "28px",
              lg: "28px",
            },
            fontWeight: "bold",
          }}
        >
          Sugerencias o Quejas
        </Typography>
      </Box>

      <Container
        maxWidth="lx"
        component="form"
        onSubmit={HandleSubmitPresentarQueja}
        sx={{
          width: "100%",
          height: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
        id="presentquejasform"
      >
        <Box
          sx={{
            mt: 0,
            width: "100%",
            height: "auto",
            display: "flex",
            flexDirection: {
              xs: "column",
              sm: "column",
              md: "row",
              lg: "row",
            },
          }}
        >
          <Stack
            container
            sx={{
              mt: 2,
              width: "100%",
              height: "auto",
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "column",
                md: "row",
                lg: "row",
              },
            }}
          >
            <Stack
              sx={{
                width: "100%",
                height: "auto",
              }}
            >
              <Typography
                sx={{
                  marginTop: {
                    xs: "20px",
                    sm: "20px",
                    md: "10px",
                    lg: "10px",
                  },
                  marginBottom: {
                    xs: "0px",
                    sm: "0px",
                    md: "0px",
                    lg: "0px",
                  },
                  fontWeight: "bold",
                  textAlign: {
                    xs: "center",
                    sm: "center",
                    md: "left",
                    lg: "left",
                  },
                }}
              >
                Prestador
              </Typography>
              <TextField
                id="prestador"
                margin="normal"
                name="codAfi "
                type="text"
                value={`${codPss} - ${descripcion}`}
                autoComplete="codAfi"
                placeholder={`${codPss}  ${descripcion}`}
                size="small"
                variant="filled"
                disabled
                sx={{
                  width: {
                    xs: "100%",
                    sm: "100%",
                    md: "90%",
                    lg: "90%",
                  },
                }}
              />

              <Typography
                sx={{
                  marginTop: {
                    xs: "30px",
                    sm: "30px",
                    md: "20px",
                    lg: "20px",
                  },
                  marginBottom: {
                    xs: "10px",
                    sm: "10px",
                    md: "10px",
                    lg: "10px",
                  },
                  fontWeight: "bold",
                  textAlign: {
                    xs: "center",
                    sm: "center",
                    md: "left",
                    lg: "left",
                  },
                }}
              >
                Contacto
              </Typography>

              <TextField
                size="small"
                placeholder="Número de Teléfono"
                autoComplete="telefono"
                id="telefono"
                name="telefono"
                value={telefono}
                onChange={HandleChangeTelefono}
                inputProps={{
                  maxLength: 12,
                }}
                error={validate().telefono}
                helperText={validate().telefono}
                sx={{
                  width: {
                    xs: "100%",
                    sm: "100%",
                    md: "90%",
                    lg: "90%",
                  },
                }}
              />

              <Box
                sx={{
                  width: "100%",
                  height: "auto",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "20px",
                }}
              >
                <Typography
                  sx={{
                    marginTop: {
                      xs: "40px",
                      sm: "40px",
                      md: "20px",
                      lg: "20px",
                    },
                    marginBottom: {
                      xs: "0px",
                      sm: "0px",
                      md: "0px",
                      lg: "0px",
                    },
                    fontWeight: "bold",
                    textAlign: {
                      xs: "center",
                      sm: "center",
                      md: "left",
                      lg: "left",
                    },
                  }}
                >
                  Envío de Documento
                </Typography>
                <Button
                  id="filequejas"
                  component="label"
                  variant="outlined"
                  sx={{
                    mt: 2,
                    mb: 2,
                    width: {
                      xs: "100%",
                      sm: "100%",
                      md: "30%",
                      lg: "30%",
                    },
                  }}
                  startIcon={<CloudUploadIcon />}
                >
                  Subir Archivo
                  <VisuallyHiddenInput
                    type="file"
                    value={""}
                    onChange={HandleAnexos}
                  />
                </Button>
                <Typography>
                  Peso: {fileAnexos?.size < 10000000 ? "Correcto" : ""}
                </Typography>
                <Typography sx={{ mb: 2 }}>
                  Archivo: {fileAnexos?.type}
                </Typography>
              </Box>
            </Stack>

            <Stack
              sx={{
                width: "100%",
                height: "auto",
              }}
            >
              <Typography
                sx={{
                  marginTop: {
                    xs: "40px",
                    sm: "40px",
                    md: "20px",
                    lg: "20px",
                  },
                  marginBottom: {
                    xs: "0px",
                    sm: "0px",
                    md: "0px",
                    lg: "0px",
                  },
                  fontWeight: "bold",
                  textAlign: {
                    xs: "center",
                    sm: "center",
                    md: "left",
                    lg: "left",
                  },
                }}
              >
                Detalle
              </Typography>
              <TextField
                sx={{
                  mt: 2,
                  mb: 0,
                  mx: 0,
                  width: {
                    xs: "100%",
                    sm: "100%",
                    md: "90%",
                    lg: "90%",
                  },
                  height: "auto",
                }}
                placeholder="Describa su queja o sugerencia"
                autoComplete="detalle"
                id="detalle"
                name="detalle"
                size="small"
                multiline
                rows={12}
                value={detalle}
                onChange={HandleChangeDetalle}
                error={validate().detalle}
                helperText={validate().detalle}
              />
            </Stack>
          </Stack>
        </Box>

        {telefono && detalle ? (
          <Button
            id="enviar"
            type="submit"
            variant="contained"
            color="success"
            style={{
              width: "auto",
            }}
            sx={{ mt: 2, mb: 2 }}
          >
            Enviar
          </Button>
        ) : (
          <Button
            id="enviar"
            type="button"
            variant="contained"
            style={{
              width: "auto",
            }}
            sx={{ mt: 2, mb: 2 }}
          >
            Enviar
          </Button>
        )}

        {isFetching && (
          <ReactLoading type="spokes" color="#0000FF" height={100} width={50} />
        )}
      </Container>
    </Container>
  );
};

export default FormPresentarQuejas;
